module.exports = __webpack_public_path__ + "static/img/son11_active.b48ecb6b.png";